import React from "react";
import { Row } from "react-bootstrap";
import CourseItem from "./course";
const CourseList = ({ courses }) => {
  // Sort courses by title (handles 1-9 then a-z)
  const sortedCourses = courses
    ? [...courses].sort((a, b) => {
        const titleA = a.title || "";
        const titleB = b.title || "";
        return titleA.localeCompare(titleB, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      })
    : [];

  // Strip the numeric prefix (e.g., "1-", "2-") from course titles
  const stripPrefix = (title) => {
    if (!title) return title;
    // Match pattern like "1-", "2-", etc. at the start
    return title.replace(/^\d+-/, "");
  };

  return (
    <Row>
      {sortedCourses.map((course) => {
        // Create a modified course object with stripped title
        const courseWithStrippedTitle = {
          ...course,
          title: stripPrefix(course.title),
        };
        return (
          <CourseItem key={course._id} course={courseWithStrippedTitle} />
        );
      })}
    </Row>
  );
};

export default CourseList;
